module.exports = __webpack_public_path__ + "media/images/social-share-button/hacker_news-b117e036a024756086abd26a53500554.svg";